export const COL_SPAN = {
  ID: 1,
  NAME: 4,
  TYPE: 2,
  CATEGORY: 2,
  LAST_UPDATE: 2,
  ACTIONS: 1,
}
